export const FETCH_COMPLIANCE_STATS = 'FETCH_COMPLIANCE_STATS'
export const FETCH_COMPLIANCE_STATS_FAILED = 'FETCH_COMPLIANCE_STATS_FAILED'
export const FETCH_COMPLIANCE_STATS_SUCCEEDED = 'FETCH_COMPLIANCE_STATS_SUCCEEDED'
export const FETCH_DOCUMENT_TYPE_STATS = 'FETCH_DOCUMENT_TYPE_STATS'
export const FETCH_DOCUMENT_TYPE_STATS_FAILED = 'FETCH_DOCUMENT_TYPE_STATS_FAILED'
export const FETCH_DOCUMENT_TYPE_STATS_SUCCEEDED = 'FETCH_DOCUMENT_TYPE_STATS_SUCCEEDED'
export const FETCH_PAYMENT_STATS = 'FETCH_PAYMENT_STATS'
export const FETCH_PAYMENT_STATS_FAILED = 'FETCH_PAYMENT_STATS_FAILED'
export const FETCH_PAYMENT_STATS_SUCCEEDED = 'FETCH_PAYMENT_STATS_SUCCEEDED'
export const FETCH_TOTAL_UPLOADS_STATS = 'FETCH_TOTAL_UPLOADS_STATS'
export const FETCH_TOTAL_UPLOADS_STATS_FAILED = 'FETCH_TOTAL_UPLOADS_STATS_FAILED'
export const FETCH_TOTAL_UPLOADS_STATS_SUCCEEDED = 'FETCH_TOTAL_UPLOADS_STATS_SUCCEEDED'

export const FETCH_INVOICES_STATS = 'FETCH_INVOICES_STATS'
export const FETCH_INVOICES_STATS_FAILED = 'FETCH_INVOICES_STATS_FAILED'
export const FETCH_INVOICES_STATS_SUCCEEDED = 'FETCH_INVOICES_STATS_SUCCEEDED'

export const FETCH_PENDING_INVOICES_STATS = 'FETCH_PENDING_INVOICES_STATS'
export const FETCH_PENDING_INVOICES_STATS_FAILED = 'FETCH_PENDING_INVOICES_STATS_FAILED'
export const FETCH_PENDING_INVOICES_STATS_SUCCEEDED = 'FETCH_PENDING_INVOICES_STATS_SUCCEEDED'

export const FETCH_DISCOUNT_INVOICES_STATS = 'FETCH_DISCOUNT_INVOICES_STATS'
export const FETCH_DISCOUNT_INVOICES_STATS_FAILED = 'FETCH_DISCOUNT_INVOICES_STATS_FAILED'
export const FETCH_DISCOUNT_INVOICES_STATS_SUCCEEDED = 'FETCH_DISCOUNT_INVOICES_STATS_SUCCEEDED'

export const FETCH_PAST_DUE_INVOICES_STATS = 'FETCH_PAST_DUE_INVOICES_STATS'
export const FETCH_PAST_DUE_INVOICES_STATS_FAILED = 'FETCH_PAST_DUE_INVOICES_STATS_FAILED'
export const FETCH_PAST_DUE_INVOICES_STATS_SUCCEEDED = 'FETCH_PAST_DUE_INVOICES_STATS_SUCCEEDED'

export const FETCH_EXCEPTION_INVOICES_STATS = 'FETCH_EXCEPTION_INVOICES_STATS'
export const FETCH_EXCEPTION_INVOICES_STATS_FAILED = 'FETCH_EXCEPTION_INVOICES_STATS_FAILED'
export const FETCH_EXCEPTION_INVOICES_STATS_SUCCEEDED = 'FETCH_EXCEPTION_INVOICES_STATS_SUCCEEDED'

export const FETCH_PO_INVOICES_STATS = 'FETCH_PO_INVOICES_STATS'
export const FETCH_PO_INVOICES_STATS_FAILED = 'FETCH_PO_INVOICES_STATS_FAILED'
export const FETCH_PO_INVOICES_STATS_SUCCEEDED = 'FETCH_PO_INVOICES_STATS_SUCCEEDED'

export const FETCH_VENDORS_INVOICES_STATS = 'FETCH_VENDORS_INVOICES_STATS'
export const FETCH_VENDORS_INVOICES_STATS_FAILED = 'FETCH_VENDORS_INVOICES_STATS_FAILED'
export const FETCH_VENDORS_INVOICES_STATS_SUCCEEDED = 'FETCH_VENDORS_INVOICES_STATS_SUCCEEDED'

export const FETCH_PAYMENTS_INVOICES_STATS = 'FETCH_PAYMENTS_INVOICES_STATS'
export const FETCH_PAYMENTS_INVOICES_STATS_FAILED = 'FETCH_PAYMENTS_INVOICES_STATS_FAILED'
export const FETCH_PAYMENTS_INVOICES_STATS_SUCCEEDED = 'FETCH_PAYMENTS_INVOICES_STATS_SUCCEEDED'
